import { Api } from "telegram";
import isGenericFolder from "../isGenericFolder";
import {addChannels, apiLogout} from "../../store/reducers/root";

export async function refreshChannels(client, dispatch) {
  const isLoggedIn = await client.isUserAuthorized();
  if(!isLoggedIn) {
    dispatch(apiLogout());
    window.location.reload();
  }
  const result = await client.invoke(new Api.messages.GetDialogFilters({}));
  const channels = [];
  let counter = 0;

  result.forEach((item, index) => {
    console.debug(item.className, item.title, isGenericFolder(item), item.includePeers?.length)
    if (item.className !== "DialogFilterDefault" && !isGenericFolder(item)) {
      channels.push({
        folderOrder: index,
        index: counter,
        value: item.id,
        icon: item.emoticon,
        label: item.title,
        channels: item.includePeers.map((peer) => {
          let peerType;
          let peerId;
          let tgLink;

          if (peer.className === "InputPeerChannel") {
            peerType = "channel";
            peerId = Number(peer.channelId);
            tgLink = `https://web.telegram.org/a/#-${Number(
              peer.channelId,
            ).toString(10)}`;
          } else if (peer.className === "InputPeerUser") {
            peerType = "user";
            peerId = Number(peer.userId);
            tgLink = `https://web.telegram.org/a/#${Number(
              peer.userId,
            ).toString(10)}`;
          } else if (peer.className === "InputPeerChat") {
            peerType = "chat";
            peerId = Number(peer.chatId);
            tgLink = `https://web.telegram.org/a/#-${Number(
              peer.chatId,
            ).toString(10)}`;
          } else {
            peerType = "other";
            peerId = 0;
            tgLink = "";
          }
          return {
            peerType,
            peerId,
            tgLink,
          };
        }),
      });
      counter++;
    }
  });
  console.debug(channels)
  dispatch(addChannels(channels));
}
